import React from "react";

import { Badge } from "@/components/ui/Badge";

// A tone chip. Colour never stands alone — every one of these carries a word,
// and most carry an icon too.
//
// `tone` is a TONE index from ../constants. Pass `mono` for a value a reader
// compares character by character, such as a revision or a version number.
const Chip = ({ tone, icon, label, title, mono }) => (
    <Badge
        variant="solid"
        colorIndex={tone}
        icon={icon}
        label={label}
        title={title}
        className={`rounded-full ${mono ? "font-mono" : ""}`}
        badgeStyle="px-2 py-0.5 text-[11px]"
    />
);

export default Chip;
